<div [ngStyle]="styles.border || null" class="idp-credit-banner">
  <div class="idp-credit-banner__content idp-credit-banner__first-row">
    <div
      [innerHtml]="content?.statementCreditLabel"
      [style.color]="styles.statementCreditLabel?.fontColor"
      [style.font-family]="styles.statementCreditLabel?.fontType"
      [style.font-size]="styles.statementCreditLabel?.fontSize"
      class="col-7 idp-credit-banner__content--label"
    ></div>
    <div
      [innerHtml]="content?.statementCredit"
      [style.color]="styles.statementCreditUi?.fontColor"
      [style.font-family]="styles.statementCreditUi?.fontType"
      [style.font-size]="styles.statementCreditUi?.fontSize"
      class="col-5 idp-credit-banner__content--value"
    ></div>
  </div>
  <div
    [ngClass]="styles.backgroundColor !== WHITE_COLOR ? '--dark' : '--light'"
    [style.background-color]="styles.backgroundColor"
    [style.border-top-color]="
      styles.backgroundColor !== WHITE_COLOR
        ? ''
        : getColor((styles.border || {}).border ?? '')
    "
    class="idp-credit-banner__content idp-credit-banner__second-row"
  >
    <div
      [innerHtml]="content?.totalLabel"
      [style.color]="styles.totalLabel?.fontColor"
      [style.font-family]="styles.totalLabel?.fontType"
      [style.font-size]="styles.totalLabel?.fontSize"
      class="col-6 idp-credit-banner__content--label"
    ></div>
    <div
      [ngClass]="{ '--multi': content?.total?.multiUnit }"
      [style.color]="styles.total?.fontColor"
      [style.font-family]="styles.total?.fontType"
      [style.font-size]="styles.total?.fontSize"
      class="col-6 idp-credit-banner__content--value"
    >
      <idp-simple-price-info
        [cash]="content?.total?.cash"
        [miles]="content?.total?.miles"
        [multiUnit]="content?.total?.multiUnit || false"
      ></idp-simple-price-info>
    </div>
  </div>
</div>
